import { createLocalStorageHook } from '@/hooks/browser/createLocalStorageHook'
import { z } from 'zod'

export const usePositionKey = createLocalStorageHook('position-key', z.string().optional())
